import { Divider } from "antd";
import styles from "./SuccessPage.module.scss";
import { FeedbackModal } from "./modalFeedback";
import { useState } from "react";
import { ClientId } from "~/typings/types";
import { STATIC_DOCUMENT } from "~/pages/questionnaires/v2/customer/api/apiUrls";

const baseURL = import.meta.env.VITE_APP_API_URL;

interface Props {
  isPartner?: boolean;
  questionnaireId: ClientId;
}

const ContentItem = ({ number, text }: { number: number; text: string }) => (
  <div className={styles.itemNext}>
    <div className={styles.numberNext}>
      <p>{number}</p>
    </div>
    <p className={styles.textNext}>{text}</p>
  </div>
);

const getContent = (isPartner?: boolean) => {
  if (isPartner) {
    return (
      <div className={styles.listNext}>
        <ContentItem
          number={1}
          text="В течение одного рабочего дня проверим данные и отправим на вашу почту заявление на подпись. Подпишите заявление и отправьте скан ответным письмом, после этого ваш партнёрский аккаунт будет активирован."
        />
      </div>
    );
  }

  return (
    <div className={styles.listNext}>
      <ContentItem
        number={1}
        text="В течение одного дня на электронную почту собственника бизнеса, указанную в данной анкете, придет ссылка на оплату подключения."
      />
      <ContentItem
        number={2}
        text="После оплаты подключения в течение дня на эту же электронную почту придет доступ к личному кабинету + ссылка на инструкции по работе с системой + документы на подпись."
      />
      <ContentItem
        number={3}
        text="После получения Продамусом ответного письма со сканами (либо качественными фото) документов личный кабинет будет переведен в рабочий режим."
      />
    </div>
  );
};


export const SuccessPage = ({ isPartner, questionnaireId }: Props) => {
  const [isFeedbackModalOpen, setFeedbackModalOpen] = useState(false);


const getSubtitle = (isPartner?: boolean) =>
  isPartner ? (
    <span>Мы проверим данные и свяжемся с вами в течение одного рабочего дня, ожидайте звонка менеджера.</span>
  ) : (
    <>
      <span>На ваш email было отправлено письмо.</span>
      <span>Для продолжения пройдите по ссылке в нем.</span>
      <button
        className={styles.subtitleLinkText}
        onClick={() => window.open(baseURL + STATIC_DOCUMENT + "?name=questionnaire_fill_instruction", "_blank", "noopener,noreferrer")}
      >
        Памятка по заполнению анкеты
      </button>

       <button className={styles.btnFeedback} onClick={() => setFeedbackModalOpen(true)}>
            <span>Помогите нам стать лучше</span>
            <span>Оценить процесс оформления</span>
          </button>
    </>
  );

  return (
    <div className={styles.container}>
      <div className={styles.card} style={{ marginBottom: 20 }}>
        <div className={`${styles.image} ${styles.imageMargin}`} />
        <h2 className={styles.titleSuccess} id="title-success">Анкета отправлена!</h2>
        <div className={styles.subtitleSuccess}>{getSubtitle(isPartner)}</div>

              

        <FeedbackModal
          isOpen={isFeedbackModalOpen}
          onClose={() => setFeedbackModalOpen(false)}
           questionnaireType="ru_customer"
           questionnaireId={questionnaireId}
        />
      </div>

      <div className={styles.card}>
        <h3 className={styles.titleNext}>Что дальше?</h3>
        <Divider />
        {getContent(isPartner)}
        <Divider />


        {!isPartner && <ul className={styles.textEnd}>
          <li>Можно будет принимать оплаты.</li>
          <li>Данные шаги будут дублироваться в приходящих на электронную почту письмах, так что вы точно ничего не пропустите.</li>
          <li>Желаем успешного использования системы! Надеемся, что сотрудничество принесет Вам
            только положительные эмоции и поможет приумножить ваши доходы!</li>
        </ul>}

      </div>
    </div>
  )
};
